import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios'
import Util from './util'
// import Store from '../vuex/index'

// import {Toast, MessageBox} from 'mint-ui';

axios.interceptors.request.use(config => {
    return config
}, error => {
    return Promise.reject(error)
});

axios.interceptors.response.use(response => {
    return response
}, error => {
    return Promise.resolve(error.response)
});

function errorState(response) {

    //console.log(response)
    // 如果http状态码正常，则直接返回数据
    //if(response && (response.status === 200 || response.status === 304 || response.status === 400)) {
    if (response.status == '200') {

    } else {
        // alert('请求超时，请稍后再试');
        // Toast({
        //     message: '请求超时，请稍后再试！',
        //     duration: 3000,
        // });
    }

}

function successState(response) {

    //统一判断后端返回的错误码
    if (response.status == '200') {

        if (response.data.errorCode == 0) {
        } else if (response.data.errorCode == -1) {
            // alert('服务端错误，请联系管理员')
            // Toast({
            //     message: '服务端错误，请联系管理员',
            //     duration: 3000
            // });
        } else if (response.data.errorCode == 1) {
            // alert( response.data.message)
            // Toast({
            //     message: response.data.message,
            //     duration: 3000
            // });
        } else if (response.data.errorCode == 5001) {
        }
    } else {
        // alert('网络请求错误')
        // Toast({
        //     message: '网络请求错误',
        //     duration: 3000
        // });
    }
}

const getResource = (opts, data) => {
    var tokenVal = Util.localStorageUtil.get('access_token');
    let httpDefaultOpts = { //http默认配置
        method: opts.method,
        baseURL: process.env.API_ROOT,
        url: opts.url,
        timeout: 20000,
        params: data,
        data: data,
        headers: opts.method == 'get' ? {
            'X-Requested-With': 'XMLHttpRequest',
            "Accept": "application/json",
            "Content-Type": "application/json; charset=UTF-8",
            'token': tokenVal
        } : {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json; charset=UTF-8',
            'token': tokenVal
        }
    };
    if (opts.method == 'get') {
        delete httpDefaultOpts.data
    } else {
        delete httpDefaultOpts.params
    }
    let promise = new Promise(function (resolve, reject) {
        axios(httpDefaultOpts).then(
            (response) => {
                successState(response);
                resolve(response.data)
            }
        ).catch(
            (error) => {
                errorState(error);
                reject(error)
            }
        )

    });
    return promise
};

export default {
    banner(){
        return {
            getbanner: function (data,key) {
                return getResource({
                    url: `/jxb-website/banner/img?bannerId=${key}`,
                    method: 'get'
                }, data)
            },
        }
    },
    development() {
        return {
            getdevelopment: function (data) {
                return getResource({
                    url: '/jxb-website/development',
                    method: 'get'
                }, data)
            },
        }
    },
    information() {
        return {
            getinformation: function (data, key) {
                return getResource({
                    url: `/jxb-website/information?typeId=${key}`,
                    method: 'get'
                }, data)
            },
            informationdetail: function (data, key) {
                return getResource({
                    url: `/jxb-website/information/${key}`,
                    method: 'get'
                }, data)
            },
        }
    },
    company() {
        return {
            postcompany: function (data, key) {
                return getResource({
                    url: `/jxb-website/insurance/company/query`,
                    method: 'post'
                }, data)
            },
        }
    },

    intermediary() {
        return {
            postintermediary: function (data, key) {//
                return getResource({
                    url: `/jxb-website/insurance/intermediary/query`,
                    method: 'post'
                }, data)
            },
          
        }
    },
    product() {
        return {
            postproduct: function (data) {
                return getResource({
                    url: '/jxb-website/insurance/product/query',
                    method: 'post'
                }, data)
            }
           
        }
    },
    news() {
        return {
            getnews: function (data, key) {
                return getResource({
                    url: `/jxb-website/news/${key}`,
                    method: 'get'
                }, data)
            },
            postnews: function (data, key) {
                return getResource({
                    url: `/jxb-website/news/query`,
                    method: 'post'
                }, data)
            },
            getnewstype: function (data, key) {
                return getResource({
                    url: `/jxb-website/news/type`,
                    method: 'get'
                }, data)
            },
        }
    },
}





// WEBPACK FOOTER //
// ./src/common/service.js